<div class="consumer-eligibility-status mat-typography mat-body mat-app-background">
  @if (processedResults) {
    <div>
      <!-- CONTACT INFO -->
      <div>
        <!-- No Error Header-->
        @if (!(
          processedResults.incompleteApp ||
          processedResults.errorApp ||
          processedResults.errorAppDP ||
          processedResults.contingency
          )) {
          <h1>Welcome back!</h1>
          <div class="welcome-info">
            <div>
              <span>
                {{processedResults.messages.content.eligibilityTitle.preMessage}}<a
                class="ffmForwardButton external-link" target="_blank"
              title="Opens in a new window">{{processedResults.messages.content.eligibilityTitle.link}}</a>{{processedResults.messages.content.eligibilityTitle.postMessage}}
            </span>
          </div>
          <!-- CONTACT PERSON -->
          @if (processedResults?.customerData?.homeAddress) {
            <div>
              <div class="contact-person-container">
                <h4>CONTACT PERSON</h4>
                <span class="margin-top">{{processedResults.customerData.fullName.firstName}}
                  {{processedResults.customerData.fullName.middleName}}
                {{processedResults.customerData.fullName.lastName}}</span>
                <span>{{processedResults.customerData.dateOfBirth}}</span>
                <span>{{processedResults.customerData.email}}</span>
                <span>{{processedResults.customerData.homeAddress.address}}</span>
                <span>{{processedResults.customerData.homeAddress.address2}}</span>
                <span>{{processedResults.customerData.homeAddress.city}},
                  {{processedResults.customerData.homeAddress.state}}
                {{processedResults.customerData.homeAddress.zipCode}}</span>
                <span>{{processedResults.customerData.phone}}</span>
              </div>
            </div>
          }
        </div>
      }
      <div class="message-info" [ngClass]="{ 'added-border': !processedResults.QHPIneligible }">
        @if (processedResults.messages.icon) {
          <div class="largeAlertContainer">
            <span>{{processedResults.messages.brandViolation}}</span>
          </div>
        }
        <div>
          @if (processedResults.messages.brandViolation) {
            @if (processedResults.messages.consumer) {
              <span class="subHeadingColor">{{processedResults.messages.messageTitle}}</span>
              <span class="subHeadingColor" [innerHTML]='processedResults.messages.messageContent'></span>
              <span class="generalInfo"> {{processedResults.messages.extraMessage}}</span>
            } @else {
              <span class="subHeadingColor" [innerHTML]='processedResults.messages.messageContent'></span>
              <span class="generalInfo">Coverage Year ({{processedResults.messages.coverageYear}})</span>
              <span class="generalInfo">Contact Person First Name : {{customerData.fullName.firstName}}</span>
              <span class="generalInfo">Contact Person Last Name : {{customerData.fullName.lastName}}</span>
              <span class="generalInfo">Contact Person Date of Birth : {{customerData.dateOfBirth}}</span>
              <span class="generalInfo">{{processedResults.messages.extraMessage}}</span>
            }
          } @else {
            <h3>{{processedResults.messages.messageTitle}}</h3>
            @if (processedResults.messages.messageContent) {
              <span class="subHeadingColor"
              [innerHTML]='processedResults.messages.messageContent'></span>
            }
          }
          @if (processedResults.unsupportedFam) {
            @if (processedResults.SEPfamily) {
              @if (!(
                processedResults.incompleteApp ||
                processedResults.errorApp ||
                processedResults.errorAppDP ||
                processedResults.contingency
                )) {
                <p>
                  @if (processedResults.APTC) {
                    <span>{{processedResults.messages.APTC}}</span>
                  }
                  @if (processedResults.CSR) {
                    <span>{{processedResults.messages.CSR}}</span>
                  }
                  <span>{{processedResults.messages.BothCases}}</span>
                </p>
              }
            }
          }
        </div>
      </div>
      @if (processedResults.over25) {
        @if (processedResults.messages.buttons.offExchange) {
          <div class="right margin-left">
            <a class="action-btn primary" href="#!/find-insurance/build-your-family"
            title="SHOP DIRECTLY WITH HIGHMARK">{{statusButtons.offExchange}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.healthcare) {
          <div class="right margin-left">
            <a class="action-btn primary cm_sp_healthcaregov" href="https://www.healthcare.gov"
            title="GO TO THE MARKETPLACE">{{statusButtons.healthcare}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.ffmSSO) {
          <div class="right margin-left">
            <a class="action-btn primary ffmForwardButton" title="GO TO THE MARKETPLACE">{{statusButtons.ffmSSO}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.close) {
          <div class="right margin-left">
            <a class="action-btn primary" href="javascript:console.log(' I do not believe this to be functional')"
            title="CLOSE" alt="CLOSE">{{statusButtons.close}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.highmarkDirect) {
          <div class="right margin-left">
            <a class="action-btn primary" href="http://www.highmarkdirect.com/" title="FIND A STORE"
            alt="FIND A STORE">{{statusButtons.highmarkDirect}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.newQuote) {
          <div class="right margin-left">
            <a class="action-btn primary" href="javascript:console.log('I do not believe this to be functional')"
            title="CLOSE" alt="CLOSE">{{statusButtons.close}}</a>
          </div>
        }
        @if (processedResults.messages.buttons.backBtn) {
          <div class="right margin-left">
            <a id='back-button' class="action-btn primary backButton" title="CLOSE"
            alt="CLOSE">{{statusButtons.backBtn}}</a>
          </div>
        }
      }
      @if (processedResults.unsupportedFam) {
        <div id="descriptiveInfo" class="default-white-round clearfix margin-top">
          <div>
            <div class="generalInfo">
              <div>
                <h3>{{processedResults.messages.extraMessage}}</h3>
                <p class="margin-top subHeadingColor bodyText">
                  @if (processedResults.APTC) {
                    <span>{{processedResults.messages.APTC}}</span>
                  }
                  @if (processedResults.CSR) {
                    <span>{{processedResults.messages.CSR}}</span>
                  }
                  <span>{{processedResults.messages.BothCases}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
      }
      @if (processedResults.SEPfamily) {
        <div id="descriptiveInfo" class="default-white-round clearfix margin-top">
          <div>
            <div class="generalInfo">
              <div>
                <h3>{{processedResults.messages.extraMessage}}</h3>
                <p class="margin-top subHeadingColor bodyText">
                  @if (processedResults.APTC) {
                    <span>{{processedResults.messages.APTC}}</span>
                  }
                  @if (processedResults.CSR) {
                    <span>{{processedResults.messages.CSR}}</span>
                  }
                  <span>{{processedResults.messages.BothCases}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
      }
      @if (processedResults.showPageContent) {
        @if (!processedResults.QHPIneligible) {
          @if (!processedResults.over25) {
            <!-- APTC Content / form -->
            @if (processedResults.APTC) {
              <div class="aptc-content-form margin-top">
                <!-- What is APTC?? -->
                <div>
                  <h3>{{processedResults.messages.content.APTC.messageTitle}}</h3>
                  <span class="margin-top">{{ processedResults.messages.content.APTC.messageContent}}</span>
                  @if (!processedResults.isProducer) {
                    <span
                      class="margin-top"><strong>{{processedResults.messages.content.APTC.messageContentConsumer}}</strong></span>
                    }
                  </div>
                  <!-- It's this! -->
                  <div>
                    <div>
                      <span class="same-link-blocky thicc-text">
                        <strong>-${{processedResults.APTCYearly}}</strong>
                        <span class="subHeadingColor">/year</span>
                      </span>
                      <span class="same-link-blocky">
                        <strong>-${{processedResults.APTCMonthly}}</strong>
                        <span class="subHeadingColor">/month</span>
                      </span>
                    </div>
                  </div>
                </div>
              }
              @if (processedResults.CSR) {
                <div id="CSR" class="generalInfo clearfix border-bottom">
                  <div class="eligibilityLeft80">
                    <h3>{{processedResults.messages.content.CSR.messageTitle}}</h3>
                    <span
                    class="margin-top subHeadingColor bodyText">{{processedResults.messages.content.CSR.messageContent}}</span>
                  </div>
                  <div class="eligibilityRight20">
                    <div class="smallAlertContainerRight">
                      <strong class="qualify">{{processedResults.messages.content.CSR.youQualify}}</strong>
                    </div>
                  </div>
                </div>
                <hr />
              }
            }
          }
        }
      </div>
      @if (processedResults.showPageContent) {
        @if (!processedResults.QHPIneligible) {
          <div class="eligible-applicants margin-top">
            <!-- Over-25 Applicants, Tobacco Form-->
            @if (!processedResults.over25) {
              <!-- Header -->
              <div class="header">
                <h3>{{processedResults.messages.content.familyInfoTitle}}</h3>
                <div>
                  <span>Tobacco user?</span>
                  @if (processedResults.messages.content.tobaccoIconShowup) {
                    <img id="tobaccoMoreInfo" class="display-inline cursor-pointer"
                      src="bootstrap/img/icons/16px/16__Info.png" alt="Tobacco User?"
                      matTooltip="{{processedResults.messages.content.tobaccoPopup}}">
                    }
                  </div>
                </div>
                <!-- Form -->
                <div class="tobacco-form" [formGroup]="tobaccoForm">
                  <!-- LOOP THROUGH ELIGIBLE APPLICANTS -->
                  @for (eligiblePerson of processedResults.processedEligibilityResults.eligible; track trackByIndex(i, eligiblePerson); let i = $index) {
                    <div class="eligible-applicant-wrapper"
                      [formGroupName]="eligiblePerson.personID">
                      <div class="eligible-applicant" [ngClass]="{even: index % 2 === 0, odd: index % 2 !== 0}">
                        <!-- Expand/Collapse -->
                        <div class="toggle-drawer-button"
                          (click)="eligibleApplicantDrawers[index] = !eligibleApplicantDrawers[index]">
                          @if (eligibleApplicantDrawers[index]) {
                            <span class="material-symbols-outlined">keyboard_arrow_right</span>
                          }
                          @if (!eligibleApplicantDrawers[index]) {
                            <span class="material-symbols-outlined">keyboard_arrow_down</span>
                          }
                        </div>
                        <!-- Person -->
                        <div class="application-info-section">
                          <strong>{{eligiblePerson.fullName.firstName}} {{eligiblePerson.fullName.middleName}}
                          {{eligiblePerson.fullName.lastName}}</strong>
                          <span>{{eligiblePerson.dateOfBirth}}</span>
                          <span>ZIP Code: <strong>{{eligiblePerson.homeAddress.zipCode}}</strong></span>
                          <span>County: <strong>{{eligiblePerson.homeAddress.county}}</strong></span>
                        </div>
                        <!-- Tobacco? -->
                        <div class="tobacco-section">
                          <!-- TOBACCO QUESTIONS -->
                          @if (isAdult(processedResults.currentDate, eligiblePerson)) {
                            <!-- RADIO GROUP -->
                            <div class="tobacco-radio-group">
                              <mat-radio-group formControlName="isUser"
                                (change)="tobaccoUsageChanged(eligiblePerson.personID, $event)">
                                <mat-radio-button value="Y">Yes</mat-radio-button>
                                <mat-radio-button value="N">No</mat-radio-button>
                              </mat-radio-group>
                            </div>
                            <!-- DATE PICKER -->
                            <div class="tobacco-text-box">
                              <mat-form-field appearance="outline"
                                [ngStyle]="{ 'visibility' : tobaccoFormControlsAsJson[eligiblePerson.personID]['isUser'] !== 'Y' ? 'hidden' : 'visible' }">
                                <mat-label>Last Tobacco Usage</mat-label>
                                <input matInput [matDatepicker]="datePicker" formControlName="lastUseDate"
                                  placeholder="MM/DD/YYYY"
                                  (dateChange)="tobaccoDateChanged('change', $event, eligiblePerson.personID)">
                                  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                                  <mat-datepicker #datePicker></mat-datepicker>
                                  @if (tobaccoFormControls[eligiblePerson.personID]?.controls['lastUseDate']?.errors?.required) {
                                    <mat-error
                                      >
                                    This field is required.</mat-error>
                                  }
                                  @if (tobaccoFormControls[eligiblePerson.personID]?.controls['lastUseDate']?.errors?.dateTooOldOrTooFuturistic) {
                                    <mat-error
                                      >
                                    Date must be within the last 60 days.</mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="eligible-applicant-details"
                          [ngClass]="{ 'slide-in': eligibleApplicantDrawers[index], 'slide-out': !eligibleApplicantDrawers[index] }">
                          <div>
                            <ul>
                              <li>{{processedResults.messages.content.familyInfoDetail.lineOne}}</li>
                              @if (processedResults.showAPTC) {
                                <li>
                                  {{processedResults.messages.content.familyInfoDetail.lineTwoPre}}<strong>${{this.APTCPrice}}</strong>{{processedResults.messages.content.familyInfoDetail.lineTwoPost}}
                                </li>
                              }
                              @if (processedResults.CSR) {
                                <li>
                                {{processedResults.messages.content.familyInfoDetail.lineThree}}</li>
                              }
                            </ul>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!processedResults.unsupportedFam) {
                  @if (!processedResults.SEPfamily) {
                    <!-- Eligible Primary -->
                    @if (!processedResults.over25) {
                      <div class="eligible-primary margin-top">
                        <h3>
                          {{processedResults.messages?.content?.primary?.messageTitle}}
                          @if (processedResults.messages?.content?.primary?.iconShowup) {
                            <img id="primaryApplicantInfo"
                              src="bootstrap/img/icons/16px/16__Info.png" alt="Primary Applicant"
                              matTooltip="{{processedResults?.content?.primary?.iconPopup}}">
                          }
                        </h3>
                        <div>
                          <div class="subHeadingColor">
                            <span>{{processedResults.messages?.content?.primary?.messageContent}}</span>
                          </div>
                          <!-- APPLICANT SELECTOR -->
                          <div>
                            <div [formGroup]="applicantForm">
                              <mat-form-field appearance="outline">
                                <!-- <mat-label>{{entry?.formControlAttributes?.label}}<span *ngIf="valueRequired" style="color: #a71919;">*</span></mat-label> -->
                                <mat-select [formControlName]="'selectedApplicant'">
                                  @for (option of applicantContainer; track option) {
                                    <mat-option [value]="option.value">
                                    {{option.label}}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Eligible Effective Date -->
                    <div class="eligibleStartDate">
                      <h3>{{processedResults.messages.content.startDate.messageTitle}}</h3>
                      <div>
                        <div class="subHeadingColor">
                          <span>{{processedResults.messages.content.startDate.messageContent}}</span>
                        </div>
                        <div>
                          @if (effectiveDateForm) {
                            <div id="effectiveDate" [formGroup]="effectiveDateForm">
                              <mat-form-field appearance="outline">
                                <mat-select formControlName="selectedEffectiveDate"
                                  [disabled]="!(effectiveDateContainer.length > 1)">
                                  @for (option of effectiveDateContainer; track option) {
                                    <mat-option [value]="option.value">
                                    {{option.label}}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    @if (processedResults.over25) {
                      <div class="right">
                        @if (processedResults.messages?.statusButtons?.close) {
                          <a class="action-btn primary"
                            href="javascript:console.log('I do not believe this to be functional')"
                          >{{processedResults.messages?.statusButtons?.close}}</a>
                        }
                        @if (processedResults.messages?.statusButtons?.healthcare) {
                          <a class="action-btn primary cm_sp_healthcaregov" href="https://www.healthcare.gov"
                          >{{processedResults.messages?.statusButtons?.healthcare}}</a>
                        }
                        @if (processedResults.messages?.statusButtons?.offExchange) {
                          <a class="action-btn primary" href="#!/find-insurance/build-your-family"
                          >{{processedResults.messages?.statusButtons?.offExchange}}</a>
                        }
                      </div>
                    }
                    @if (!processedResults.over25) {
                      @if (processedResults.CSRMessage) {
                        <div class="smallAlertContainerLeft margin-left">
                          <p class="subHeadingColor">{{processedResults.messages.content.extraMessage.firstPara}}</p>
                          <br />
                          <p class="subHeadingColor">{{processedResults.messages.content.extraMessage.secondPara}}</p>
                          <br />
                          <p class="subHeadingColor">{{processedResults.messages.content.extraMessage.thirdPara}}</p>
                          <br />
                        </div>
                      }
                      @if (processedResults.QSEHRAorICHRA) {
                        <div class="smallAlertContainerLeft margin-left">
                          <p class="margin-top subHeadingColor bodyText">
                            <span>{{processedResults.messages.QSEHRAorICHRA}}</span>
                          </p>
                        </div>
                      }
                      <div class="button-container">
                        <div>
                          <button mat-raised-button color="primary" id="view-plans-submission" (click)="submit()"
                          [ngClass]="{ 'disabled': processedResults.QSEHRAorICHRA }">View Plans</button>
                          <button mat-raised-button color="primary" id="returnToHealthcareGovSiteButton"
                          (click)="goToMarketplace()">{{processedResults.messages.content.links.returnHealthcareGov}}</button>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            }
          }
        </div>
        @if (processedResults.showPageContent) {
          @if (!processedResults.over25) {
            @if (processedResults.ineligibleApplicants) {
              <div id="ineligibleApplicants" class="default-white-round clearfix margin-top"
                >
                <div class="largeAlertContainer">
                  <h3>{{processedResults.messages.content.extraMessage.extraHeadline}}</h3>
                </div>
                <div class="ineligibleList margin-top">
                  <!-- LOOP THROUGH NON-ELIGIBLE APPLICANTS -->
                  @for (ineligiblePerson of processedResults.processedEligibilityResults.ineligible; track trackByIndex(i, ineligiblePerson); let i = $index) {
                    <div
                      class="ineligibleApplicant clearfix border-bottom"
                      [ngClass]="{even: index % 2 === 0, odd: index % 2 !== 0}">
                      <!-- DEMOGRAPHICS -->
                      <div class="ineligibleData eligibilityLeft80">
                        <strong>{{ineligiblePerson.fullName.firstName}} {{ineligiblePerson.fullName.middleName}}
                        {{ineligiblePerson.fullName.lastName}}</strong><br>
                        <span>{{ineligiblePerson.dateOfBirth}}</span>
                      </div>
                      <div class="ineligibleData eligibilityRight20">
                        @if (ineligiblePerson.CHIP) {
                          <div class="ineligibleButton">
                            <a href="{{ineligiblePerson.CHIPLink}}" class="external-link"
                            target="_blank">{{processedResults.messages.content.links.qualifyCHIP}}</a>
                          </div>
                        }
                        @if (ineligiblePerson.medicaid) {
                          <div class="ineligibleButton">
                            <a href="{{ineligiblePerson.medicaidLink}}" class="external-link"
                            target="_blank">{{processedResults.messages.content.links.qualifyMedicaid}}</a>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
                @if (processedResults.messages.buttons.bottomClose) {
                  <br />
                  <div class="right">
                    <a class="action-btn primary" href="javascript:console.log('I do not believe this to be functional')"
                    title="text link" alt="text link">{{processedResults.statusButtons.close}}</a>
                  </div>
                }
              </div>
            }
          }
        }
      } @else {
        <div class="spinner-container">
          <mat-spinner [diameter]="100"></mat-spinner>
        </div>
      }
    </div>
